import React from 'react';
import {
	FooterLinkItems,
	FooterLinkTitle,
	FooterLink,
	FooterLogo,
	SocialIcon,
	FooterRights,
	FooterSocialIcon,
	FooterWrapper,
	FooterAddress,
	FooterColumn,
	FooterGrid,
} from './FooterStyles';
import { footerData, footerSocialData, footerSocialData2 } from '../../data/FooterData';
import { Row, Section } from '../../globalStyles';

function Footer() {
	return (
		<Section padding="4rem 0 2rem 0">
			<FooterWrapper>
				<FooterGrid justify="space-between">
					<FooterColumn id="footerLogo">
						<FooterLogo to="/">
							<SocialIcon src="./assets/NavbarLogo.png" />
							Strings and more
						</FooterLogo>
						<FooterLinkTitle style={{marginBottom: "8px", marginTop: "30px", color: "white"}}>Kontakt</FooterLinkTitle>
						<FooterAddress>
							Sandra Djuric und Andreas Reiss
							Tel.: 07478 / 91227 und	E-mail: stringsandmore@web.de
						</FooterAddress>
						<Row align="center" margin="auto  0 0 0" gap="1rem">
							{footerSocialData.map((social, index = 0) => (
								<FooterSocialIcon
									key={index}
									href="https://m.facebook.com/Strings-and-more-eV-254422857929230/"
									target="_blank"
									aria-label={social.name}
								>

									{social.icon}
								</FooterSocialIcon>
							))}

							{footerSocialData2.map((social, index = 0) => (
								<FooterSocialIcon
									key={index}
									href="https://www.instagram.com/strings_and_more/?hl=de"
									target="_blank"
									aria-label={social.name}
								>

									{social.icon}
								</FooterSocialIcon>
							))}

						</Row>
					</FooterColumn>
					{footerData.map((footerItem, index) => (
						<FooterLinkItems key={index}>
							<FooterLinkTitle>{footerItem.title}</FooterLinkTitle>
							{footerItem.links.map((link, linkIndex) => (
								<FooterLink key={linkIndex} to="/impressum">
									{link}
								</FooterLink>
							))}
						</FooterLinkItems>
					))}
				</FooterGrid>
				<FooterRights>Strings and more Website seit 2022</FooterRights>
			</FooterWrapper>
		</Section>
	);
}

export default Footer;